import type { LiabilityFormLayout } from "../types";

export const loanTermLayout = (): LiabilityFormLayout => {
  return {
    render: 'loanTerm'
  }
}
